import { AxiosResponse } from 'axios';
import { api } from 'src/common/utils';

import { LegalEntityProps } from '../../types';

const LEGAL_ENTITIES_ROOT_PATH = 'legal_entities';

export const updateLegalEntity = async (
  id: string,
  payload: Partial<LegalEntityProps>
): Promise<AxiosResponse<LegalEntityProps>> => {
  if (!id) throw new Error('Missing legal entity id');
  return api.patch(`/${LEGAL_ENTITIES_ROOT_PATH}/${id}`, payload);
};

export const createLegalEntity = async (
  payload: Partial<LegalEntityProps>
): Promise<AxiosResponse<LegalEntityProps>> => {
  return api.post(`/${LEGAL_ENTITIES_ROOT_PATH}`, payload);
};

export const fetchLegalEntity = async (id: string): Promise<LegalEntityProps> => {
  const url = `/${LEGAL_ENTITIES_ROOT_PATH}/${id}`;
  const response = await api.get(url);
  return response.data as LegalEntityProps;
};
